import React from 'react';
import slackLogo from '../../public/slack.jpg';
import KatalMetricsPublisher from '@amzn/katal-metrics/lib/KatalMetricsPublisher';
import { Link } from 'src/components/Link';
import { SpaceBetween } from '@cloudscape-design/components';

interface CommunitySectionProps {
  actionMetricsPublisher: KatalMetricsPublisher;
}

export const CommunitySection = ({
  actionMetricsPublisher,
}: CommunitySectionProps) => {
  return (
    <section className="community-section">
      <div className="community-section__container">
        <div className="community-section__heading">
          <h2>Community</h2>
        </div>
        <div className="community-section__wrapper">
          <div className="community-section__content">
            <h3>Model Registry</h3>
            <p>
              Share your trained or untrained model with the rest of Amazon.
              Consume shared models from{' '}
              <strong>MLPigeon Model Registry</strong> to optimize your
              workflow.
            </p>
            <div className="community-section__list">
              <ul className="list-disc list-inside">
                <li>
                  Model sharing and consuming shared models via MLPigeon
                  workflow
                </li>
                <li>Browse all company-wide shared models</li>
                <li>
                  Model sharing and consumption with{' '}
                  <strong>controlled access</strong> (coming soon)
                </li>
              </ul>
            </div>

            <Link
              to={'/modelRegistry'}
              onClick={() => {
                actionMetricsPublisher?.publishCounterMonitor(
                  'ModelRegistry',
                  1,
                );
              }}
            >
              Browse Models
            </Link>
          </div>
          <div className="community-section__content">
            <h3>Join Us</h3>
            <SpaceBetween size="m" direction="horizontal" alignItems="center">
              <img src={slackLogo} alt="slack" />
              <Link
                to="https://amazon.enterprise.slack.com/archives/C01BPFC6JE6"
                external
              >
                #mlpigeon-support
              </Link>
            </SpaceBetween>
            <p>
              Please{' '}
              <Link
                to="https://email-list.corp.amazon.com/email-list/expand-list/mlpigeon-newsletter"
                external
              >
                subscribe
              </Link>{' '}
              to our <strong>newsletter</strong>! We send out a recap of changes
              and added features{' '}
              <Link
                to="https://w.amazon.com/bin/MLPigeon/MonthlyNewsletterHistory"
                external
              >
                periodically
              </Link>
              .
            </p>
            <p>
              As of June 2024, over <strong>1000</strong> AWS accounts (Across{' '}
              <strong>420</strong>+ Two-Pizza teams and <strong>150</strong>+ VP
              Organizations) have onboarded to MLPigeon.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
